import React, { useEffect, useState } from "react";
import { Row, Col, Container, Input } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "components/VerticalLayout/Footer";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import {get } from "helpers/api_helper";
import * as api from "../../constants/api_constants";

function ViewShippingBilling() {
  const { customerId } = useParams();
  const [customerData, setCustomerData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchCustomerData(customerId);
  }, [customerId]);

  const fetchCustomerData = async (id) => {
    try {
      const customerFetchedData = await get(api.GET_CUSTOMER_BY_ID(id));
      setCustomerData(customerFetchedData?.customerPageResponse?.data[0]);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  const renderAddress = (address) => (
    <>
      <Row className="mb-3">
        <label className="col-form-label">Country</label>
        <Input
          type="text"
          value={address?.country || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      
      <Row className="mb-3">
        <label className="col-form-label">Province</label>
        <Input
          type="text"
          value={address?.province || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <label className="col-form-label">City</label>
        <Input
          type="text"
          value={address?.city || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <label className="col-form-label">Zip Code</label>
        <Input
          type="text"
          value={address?.zipCode || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
      <Row className="mb-3">
        <label className="col-form-label">Address</label>
        <Input
          type="text"
          value={address?.street || "N/A"}
          disabled
          className="form-control"
        />
      </Row>
    </>
  );

  return (
    <div className="page-content">
      <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
        <PageSubHeader
          heading={"Billing and Shipping Details"}
          routePath={"Home"}
          pageName={"Billing - Shipping"}
        />
        <Row className="justify-content-around mt-3">
          <Col md={5}>
            <h6 className="text-primary">Billing Address</h6>
            {renderAddress(customerData?.billingAddress)}
          </Col>
          <Col md={5}>
            <h6 className="text-primary">Shipping Address</h6>
            {renderAddress(customerData?.shippingAddress)}
          </Col>
        </Row>
      </Container>
      <Footer
        saveText="Edit Billing/Shipping"
        save={() => navigate(`/addShippingBilling/${customerId}`)}
        showBackConfirmation = {false}
      />
    </div>
  );
}

export default ViewShippingBilling;
